import React, { useState, useMemo } from "react";
import { Table, Button, Row, Col, Form } from "react-bootstrap";

function TableComponent({
  columns,
  data,
  rowsPerPage = 10,
  maxHeight = 400,
  headerClass = "table-dark"
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredData = useMemo(() => {
    if (!searchTerm) return data;
    return data.filter(row =>
      columns.some(col => {
        const value = row[col.key];
        return value
          ? value.toString().toLowerCase().includes(searchTerm.toLowerCase())
          : false;
      })
    );
  }, [searchTerm, data, columns]);

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentData = filteredData.slice(startIndex, startIndex + rowsPerPage);

  return (
    <div>
      {/* 🔍 Search */}
      <Form className="mb-2" style={{ width: 250, marginLeft: "auto" }}>
        <Form.Control
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
        />
      </Form>

      {/* ✅ SCROLL CONTAINER */}
      <div
        style={{
          maxHeight: `${maxHeight}px`,
          overflowY: "auto",
          border: "1px solid #dee2e6",
          borderRadius: "4px"
        }}
      >
        <Table striped bordered hover className="mb-0 text-center">
          <thead
            className={headerClass}
            style={{ position: "sticky", top: 0, zIndex: 2 }}
          >
            <tr>
              {columns.map(col => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {currentData.length > 0 ? (
              currentData.map((row, index) => (
                <tr key={row.id || index}>
                  {columns.map(col => (
                    <td key={col.key}>
                      {col.format
                        ? col.format(row[col.key], row, startIndex + index)
                        : row[col.key]}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length}>No data found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* 📄 Pagination */}
      {totalPages > 1 && (
        <Row className="mt-2 align-items-center">
          <Col xs="auto">
            <Button size="sm" onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}>
              Prev
            </Button>
          </Col>

          <Col className="text-center">
            Page {currentPage} of {totalPages}
          </Col>

          <Col xs="auto" className="text-end">
            <Button
              size="sm"
              onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
            >
              Next
            </Button>
          </Col>
        </Row>
      )}
    </div>
  );
}

export default TableComponent;
